import "./sw-feedback.module.css";
import { html } from "lit-html";
import { LANGUAGE } from "../../global.ts";
import Strings from "../../../models/Strings.json";

export default (hero) => html`
    <div
        id="sw-feedback"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-lg max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3 class="text-2xl font-semibold text-theme">
                        ${Strings.feedback1[LANGUAGE]}
                    </h3>
                    <button
                        title="${Strings.close[LANGUAGE]}"
                        type="button"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="sw-feedback">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">${Strings.close[LANGUAGE]}</span>
                    </button>
                </div>
                <!-- Modal body -->
                <form class="p-4 md:p-5">
                    <div class="grid gap-4 mb-4 grid-cols-2">
                        <div
                            class="my-5 col-span-2 flex items-center justify-center">
                            <svg
                                onclick="heartbank.alertAdmin('feedback/click/stars/1')"
                                id="sw-star-1"
                                class="star w-8 h-8 ms-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 20">
                                <path
                                    d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                            </svg>
                            <svg
                                onclick="heartbank.alertAdmin('feedback/click/stars/2')"
                                id="sw-star-2"
                                class="w-8 h-8 ms-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 20">
                                <path
                                    d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                            </svg>
                            <svg
                                onclick="heartbank.alertAdmin('feedback/click/stars/3')"
                                id="sw-star-3"
                                class="w-8 h-8 ms-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 20">
                                <path
                                    d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                            </svg>
                            <svg
                                onclick="heartbank.alertAdmin('feedback/click/stars/4')"
                                id="sw-star-4"
                                class="w-8 h-8 ms-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 20">
                                <path
                                    d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                            </svg>
                            <svg
                                onclick="heartbank.alertAdmin('feedback/click/stars/5')"
                                id="sw-star-5"
                                class="w-8 h-8 ms-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 20">
                                <path
                                    d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                            </svg>
                        </div>
                        <div class="col-span-2">
                            <section class="flex justify-between">
                                <label
                                    for="sw-feedback-input"
                                    class="mb-2 text-xl font-bold text-gray-900 dark:text-white"
                                    >${hero
                                        ? hero.displayName
                                            ? Strings.feedback16[LANGUAGE] +
                                              hero.displayName
                                            : Strings.feedback16[LANGUAGE] +
                                              hero.email
                                        : Strings.feedback15[LANGUAGE]}</label
                                >
                                <aside>
                                    <span
                                        title="${Strings.map23[LANGUAGE]}"
                                        id="sw-feedback-passkeys"
                                        class="${hero
                                            ? ""
                                            : "hidden"} mr-1 cursor-pointer text-2xl">
                                        🔑
                                    </span>
                                    <span
                                        title="${Strings.map22[LANGUAGE]}"
                                        id="sw-feedback-settings"
                                        class="${hero
                                            ? ""
                                            : "hidden"} cursor-pointer text-2xl">
                                        ⚙️
                                    </span>
                                </aside>
                            </section>
                            <textarea
                                id="sw-feedback-input"
                                onblur="heartbank.alertAdmin('feedback/type/', this.value)"
                                rows="4"
                                class="block p-2.5 w-full h-60 text-lg text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 placeholder-gray-400 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder="${Strings.feedback2[LANGUAGE]}"
                                required></textarea>
                        </div>
                    </div>
                    <p
                        id="sw-feedback-message"
                        class="text-sm font-medium mt-5 text-orange-600 dark:text-orange-500"></p>
                    <section
                        class="w-full mt-5 inline-flex items-center justify-around">
                        <button
                            type="submit"
                            onclick="heartbank.alertAdmin('feedback/click/submit')"
                            class="text-white w-32 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                            ${Strings.feedback4[LANGUAGE]}
                        </button>
                        <button
                            id="sw-login"
                            onclick="heartbank.alertAdmin('feedback/click/login')"
                            type="button"
                            class="${hero
                                ? "hidden"
                                : ""} text-white w-32 bg-hb hover:bg-hb/25 focus:ring-4 focus:outline-none focus:ring-hb/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-hb dark:hover:bg-hb/50 dark:focus:ring-hb/10">
                            ${Strings.feedback11[LANGUAGE]}
                        </button>
                        <button
                            id="sw-logout"
                            onclick="heartbank.alertAdmin('feedback/click/logout')"
                            type="button"
                            class="${hero
                                ? ""
                                : "hidden"} text-white w-32 bg-orange-500 hover:bg-orange-500 focus:ring-4 focus:outline-none focus:ring-orange-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-orange-500 dark:hover:bg-orange-500 dark:focus:ring-orange-500">
                            ${Strings.feedback5[LANGUAGE]}
                        </button>
                        <button
                            data-modal-hide="sw-feedback"
                            type="button"
                            class="hidden text-white w-24 bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                            ${Strings.close[LANGUAGE]}
                        </button>
                    </section>
                </form>
                <section
                    class="w-full my-3 pb-3 inline-flex items-center justify-center">
                    <aside
                        id="sw-feedback-hb"
                        onclick="heartbank.alertAdmin('feedback/click/heartbank')"
                        class="cursor-pointer moul self-end text-base font-extralight whitespace-nowrap text-gray-500 dark:text-gray-400">
                        Heart
                        <svg
                            class="mt-[-4px] ml-[-8px] mr-[-4px] inline fill-hb"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="25"
                            height="25">
                            <path
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                transform="rotate(45 12 12)" />
                        </svg>
                        ank<sup>®</sup>
                    </aside>
                </section>
            </div>
        </div>
    </div>
`;
